module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-right-left.2c356146.png";